import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import AccountSummaryPage from "components/pages/AccountSummaryPage";
import Classes from "model";
import { useEffect } from "react";

export default function CaptureQuickTourAccounts(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });
    
    return <AccountSummaryPage />
}